export default function VerificationEmailSent () {
  return (
    <div>
      <h1>Confirm Email Address</h1>
      <p>Please confirm your email address.</p>
    </div>
  )
}
